import { createClient } from '@supabase/supabase-js'
// SupaBaeseのURLと公開可能キーを環境変数から取得
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

// SupaBaseクライアントを作成してエクスポート
export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
    auth: {
        flowType: 'pkce'
    }
});